module.exports = __webpack_public_path__ + "static/media/save-icon.cc78fcff.svg";